"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef } from "react";
export default function HeroDeSesiones() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrolled = window.scrollY;
        parallaxRef.current.style.transform = `translateY(${scrolled * 0.3}px)`;
      }
    };
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!mediaQuery.matches) {
      window.addEventListener("scroll", handleScroll);
    }
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return <section className="relative w-full h-screen overflow-hidden bg-dark-background">
      <div ref={parallaxRef} className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1512785/img/image_58ld3zui.png)] will-change-transform" />
      <div className="absolute inset-0 bg-black/40" />
      <div ref={ref} className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] opacity-100 translate-y-0 !bg-[url(https://guillermobogao.com/wp-content/uploads/2026/02/image_1sxgk4ay.png)] !bg-[url(https://guillermobogao.com/wp-content/uploads/2026/02/F3F76C03-B571-437A-A9A9-9C8E12B54921.png)] !bg-[url(https://guillermobogao.com/wp-content/uploads/2026/02/F3F76C03-B571-437A-A9A9-9C8E12B54921.png)]">
        <h1 className="mb-4 max-w-4xl font-display text-4xl font-bold leading-tight !text-[hsl(0,0%,100%)] md:text-5xl lg:text-6xl">Avanza con claridad</h1>
        <p className="mb-8 max-w-2xl text-lg !text-[hsl(0,0%,100%)] md:text-xl">Trabajamos juntos para identificar lo que te frena y convertirlo en pasos claros y accionables.</p>
        <Link to="/ContactReserveSessionPage">
          <Button size="lg" className="shadow-medium hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
            Reserva tu sesión
          </Button>
        </Link>
      </div>
    </section>;
}